module.exports = __webpack_public_path__ + "img/hcp-grid2.c06d8137.jpg";